import { container, instanceCachingFactory } from 'tsyringe';
import { initStore, STORE_TOKEN } from 'stores/store';

export const registerServices = () => {
  container.register(STORE_TOKEN, {
    useFactory: instanceCachingFactory(initStore),
  });
};
